import * as React from 'react'
import styles from './RadioButton.module.css'

type RadioButtonT = {
  id: string,
  checked?: boolean,
  name?: string,
  value?: string,
  children?: React.ReactNode
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void,
}

function RadioButton({ id, checked, name = 'radio', value, onChange, children }: RadioButtonT) {
  const inputValue = value ?? id
  return (
    <>
      <input
        id={id}
        name={name}
        type="radio"
        value={inputValue}
        checked={checked}
        className={styles.input}
        onChange={(e) => onChange?.(e)}
      />
      <label className={styles.label} htmlFor={id}>
        <div className={styles.check}>
          <span className={styles.dot} />
        </div>
        {children}
      </label>
    </>
  )
}

export default RadioButton